import { createContext, useContext, useState, useEffect } from 'react';

export const ThemeContext = createContext({
  dark: false,
  themePref: 'system',
  setThemePref: () => {},
});

export function ThemeProvider({ children }) {
  const [themePref, setThemePrefState] = useState(
    () => localStorage.getItem('themePref') || 'system'
  );

  // Resolve whether dark mode is actually active
  const [systemDark, setSystemDark] = useState(
    () => window.matchMedia('(prefers-color-scheme: dark)').matches
  );

  // Listen for OS-level theme changes
  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e) => setSystemDark(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const dark = themePref === 'dark' || (themePref === 'system' && systemDark);

  // Apply data-theme attribute to <html> so CSS [data-theme="dark"] selector works
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
  }, [dark]);

  const setThemePref = (pref) => {
    setThemePrefState(pref);
    localStorage.setItem('themePref', pref);
  };

  return (
    <ThemeContext.Provider value={{ dark, themePref, setThemePref }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
